/**
 * @generated SignedSource<<2b1acb5da4897d2fcdee9ab42f374768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessControlSettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "AccessControlSettingsPage_query";
};
export type AccessControlSettingsPage_query$key = {
  readonly " $data"?: AccessControlSettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccessControlSettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccessControlSettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1d7c1bab67249e3e92513ad363a58ecd";

export default node;
